import React from 'react';
import PropTypes from 'prop-types';
import ANavigationLink from '../atoms/_atoms.navigation-link';

import { routes } from '../../constants';
import { MLanguagePicker } from './';

export default class MSubHeader extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showLanguage: false,
			lang: props.lang || 'nl',
		};

		this.bindHandles();
	}

	componentWillReceiveProps(props) {
		if (props.lang !== this.state.lang) {
			this.setState({ lang: props.lang });
		}
	}

	bindHandles() {
		this.toggleLanguage = this.toggleLanguage.bind(this);
		this.handlKeyDown = this.handlKeyDown.bind(this);
		this.handleLanguagePick = this.handleLanguagePick.bind(this);
	}
	toggleLanguage() {
		this.setState({ showLanguage: !this.state.showLanguage });
	}
	handlKeyDown(event) {
		if (event.keyCode === 13) {
			this.toggleLanguage();
		}
	}
	handleLanguagePick(language) {
		if (this.props.onClick) {
			this.props.onClick(language);
		}
	}

	render() {
		let languagePicker;

		if (this.state.showLanguage) {
			languagePicker = (
				<div className="wrapper">
					<MLanguagePicker
						onClick={this.handleLanguagePick}
						clickOutSide={this.toggleLanguage}
					/>
				</div>
			);
		}
		return (
			<section className="o-sub-header">
				<ul>
					<ANavigationLink href={routes.externalStore} name="Webshop" />
					<ANavigationLink href={routes.HOUSEHOLD.HOME} name="NAVIGATION.HOUSEHOLD" />
					<ANavigationLink href={routes.INDUSTRIAL.HOME} name="NAVIGATION.INDUSTRIAL" />
					{/* <li
						role="button"
						tabIndex="0"
						onClick={this.toggleLanguage}
						onKeyUp={this.handlKeyDown}
						className="m-language-picker"
					>
						{this.state.lang.toUpperCase()}▾
						{languagePicker}
					</li> */}
				</ul>
			</section>
		);
	}
}

MSubHeader.propTypes = {
	lang: PropTypes.string,
	onClick: PropTypes.func,
};

MSubHeader.defaultProps = {
	lang: 'nl',
	onClick: undefined,
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.sub-header.js